const AsksIcon = () => {
	return (
		<svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="3" y="3" width="8" height="2" fill="#5d606f" />
			<rect x="3" y="7" width="8" height="2" fill="#5d606f" />
			<rect x="3" y="11" width="8" height="2" fill="#5d606f" />
			<rect x="3" y="15" width="8" height="2" fill="#5d606f" />
			<rect x="3" y="19" width="8" height="2" fill="#5d606f" />
			<rect x="13" y="3" width="8" height="2" fill="var(--destructive)" />
			<rect x="13" y="7" width="8" height="2" fill="var(--destructive)" />
			<rect x="13" y="11" width="8" height="2" fill="var(--destructive)" />
			<rect x="13" y="15" width="8" height="2" fill="var(--destructive)" />
			<rect x="13" y="19" width="8" height="2" fill="var(--destructive)" />
		</svg>
	);
};

export default AsksIcon;
